import { connect } from 'dva';
import DocumentWarning from '../../shared/Document/DocumentWarning';
import { createSelector } from 'reselect';

import {
  getChildPassportDueDate,
  getChildPassportStatus,
} from '../../../selectors/child';
import { ChildFields } from '../../../models/child';
import { PassportWarning } from '../../../constants/document';

const mapStateToProps: (state: {
  child: ChildFields;
}) => PassportWarning = createSelector(
  getChildPassportStatus,
  getChildPassportDueDate,
  (status, passportDueDate) => {
    return {
      status,
      passportDueDate,
    };
  }
);

export default connect(mapStateToProps)(DocumentWarning);
